var map = {
	"./appstore-button.svg": "A+Y8",
	"./bootstrap.svg": "twWM",
	"./cards-red.svg": "hnJC",
	"./contact-shape.svg": "E3/Y",
	"./documentation.svg": "1kHe",
	"./documents-icon.svg": "dQQj",
	"./en.svg": "V/fb",
	"./fast-icon.svg": "Mnlz",
	"./fr.svg": "SY3Y",
	"./hero-shape-svg.svg": "UI/1",
	"./l1-curve-content2.svg": "8YLY",
	"./l1-curve-cta.svg": "yKLq",
	"./l1-curve-feature.svg": "twrx",
	"./l2-content2-icon1.svg": "NqOZ",
	"./l2-content2-icon2.svg": "V4tB",
	"./l2-content2-icon3.svg": "Lj9Q",
	"./l2-content2-icon5.svg": "kx0h",
	"./l2-content2-icon6.svg": "WpZT",
	"./l2-feature-icon1.svg": "mpZJ",
	"./l2-feature-icon2.svg": "+Jyd",
	"./l2-feature-icon3.svg": "JT2y",
	"./layout-icon.svg": "YCZc",
	"./layout.svg": "TAIR",
	"./logo-white.svg": "Ftqv",
	"./logo.svg": "tyTg",
	"./loop-icon.svg": "mW3x",
	"./map-marker.svg": "p1yQ",
	"./messege-icon.svg": "ZUsW",
	"./mobile-blue.svg": "gUDa",
	"./mobile-yellow.svg": "T8Dm",
	"./notification.svg": "GTyK",
	"./pattern.svg": "jit8",
	"./quote-right-solid.svg": "Q+39",
	"./responsive-icon.svg": "dsYy",
	"./responsive.svg": "/yoC",
	"./search-icon.svg": "blYx",
	"./support.svg": "it3w",
	"./update.svg": "rU/Z"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y2aO";